import React from "react";
import { Link } from "react-router-dom";
import { CLBadge } from "@/components/Badges";
import { Lock } from "lucide-react";

const CONF = {
  HIGH: "text-[#ccff00]",
  MEDIUM: "text-amber-400",
  "MEDIUM-HIGH": "text-[#ccff00]",
  "LOW-MEDIUM": "text-amber-400",
  LOW: "text-zinc-400",
};

export function AlphaFeedItem({ item, onView }) {
  const conf = CONF[item.confidence] || "text-zinc-300";
  return (
    <div
      data-testid={`alpha-item-${item.id}`}
      className="group grid grid-cols-12 gap-3 items-start px-4 py-4 border-b border-white/5 hover:bg-white/[0.02] transition-colors"
    >
      <div className="col-span-4 sm:col-span-1 font-mono-cl text-xs text-zinc-500">{item.time}</div>
      <div className="col-span-8 sm:col-span-2 flex items-center gap-2 flex-wrap">
        <span className="font-mono-cl text-xs font-bold text-white px-2 py-0.5 rounded bg-white/5 border border-white/10">
          {item.asset || item.market}
        </span>
        <span className="font-mono-cl text-[10px] tracking-[0.12em] text-zinc-500 uppercase">{item.market}</span>
      </div>
      <div className="col-span-12 sm:col-span-6">
        <div className="flex flex-wrap gap-1.5 mb-1.5">
          {(item.badges || []).map((b) => (
            <CLBadge key={b} label={b} />
          ))}
        </div>
        <p className="text-sm text-zinc-100 font-medium leading-snug">{item.headline}</p>
        {item.analyst_name && (
          <p className="mt-1 font-mono-cl text-[10px] tracking-[0.12em] uppercase text-[#ccff00]">By {item.analyst_name}</p>
        )}
        {item.locked ? (
          item.blur_preview ? (
            <div className="mt-2" data-testid={`alpha-exclusive-${item.id}`}>
              <p className="text-xs text-zinc-400 blur-[4px] select-none line-clamp-2" aria-hidden="true">{item.preview || "Exclusive analyst signal. Interpretation locked."}</p>
              <Link to={item.analyst_slug ? `/analyst/${item.analyst_slug}` : "/analysts"}
                className="inline-flex items-center gap-1.5 mt-1.5 text-[11px] font-mono-cl tracking-[0.14em] uppercase text-[#ccff00] hover:underline">
                <Lock className="w-3 h-3" /> Exclusive · Get access
              </Link>
            </div>
          ) : (
            <div className="flex items-center gap-1.5 mt-2 text-[11px] font-mono-cl tracking-[0.14em] uppercase text-[#ccff00]">
              <Lock className="w-3 h-3" /> Alpha members see observed data + interpretation
            </div>
          )
        ) : (
          <>
            {item.observed && (
              <p className="mt-2 text-xs text-zinc-400">
                <span className="font-mono-cl text-[10px] tracking-[0.14em] text-emerald-400 uppercase mr-1">Observed:</span>
                {item.observed}
              </p>
            )}
            {item.interpretation && (
              <p className="mt-1 text-xs text-zinc-400">
                <span className="font-mono-cl text-[10px] tracking-[0.14em] text-[#ccff00] uppercase mr-1">OnchainLyfe:</span>
                {item.interpretation}
              </p>
            )}
          </>
        )}
      </div>
      <div className="col-span-12 sm:col-span-3 flex sm:flex-col sm:items-end gap-3 sm:gap-1 mt-2 sm:mt-0">
        <div className="text-right">
          <span className="block font-mono-cl text-[9px] tracking-[0.16em] text-zinc-600 uppercase">Confidence</span>
          <span className={`font-mono-cl text-xs font-bold ${conf}`}>{item.confidence}</span>
        </div>
        <div className="text-right">
          <span className="block font-mono-cl text-[9px] tracking-[0.16em] text-zinc-600 uppercase">Impact</span>
          <span className="font-mono-cl text-xs font-bold text-zinc-200">{item.impact}</span>
        </div>
      </div>
    </div>
  );
}
